const PlusIcon = () => <img src="/assets/images/icons/plus.svg" alt="plus" />;

export default PlusIcon;
